var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:{ selected: _vm.selected },attrs:{"id":_vm.id,"aria-selected":_vm.selected.toString(),"role":"option"},on:{"click":function($event){return _vm.select(_vm.id)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }